import api, { apiRaw } from "./api";
class CadastroService {
    static async salvar(participante) {
        const url = "/cadastro";
        const res = await api.post(url, participante);
        return res.data;
    }
    static async validar(participante) {
        const url = "/cadastro";
        try {
            await apiRaw.post(url, {
                ...participante,
                validation_only: 1,
            });
            return {};
        }
        catch (error) {
            return error?.response?.data ?? ["Erro desconhecido."];
        }
    }
}
export default CadastroService;
